<template>
  <section class="c-order-items u-margin-bottom-small">
    <div class="c-order-items__header t-heading-6">
      Items
    </div>
    <div
      v-for="(item, index) in items"
      :key="index"
      class="c-order-items__item l-flex l-flex--justify-start"
    >
      <img
        class="c-order-items__item-image"
        :src="imageSrc(item)"
        :alt="item.title"
      >
      <div class="c-order-items__item-details">
        <p class="c-order-items__item-line t-heading-9 l-flex l-flex--justify-between">
          {{ item.title }}
          <span class="c-order-items__line-qty">Qty: {{ item.quantity }}</span>
        </p>
        <p class="c-order-items__item-line">
          {{ item.price }}
        </p>
        <div class="c-order-items__item-line t-heading-9 t-heading-9--light">
          <span
            v-for="prop in item.properties" 
            :key="prop[0]"
          >
            <template v-if="visibleProperty(prop[0])">
              {{ prop[0] | capitalize }}: {{ prop[1] }}<br>
            </template>
          </span>
        </div>
      </div>
    </div>
  </section>  
</template>

<script>
import get from 'lodash/get';

export default {
  name: 'OrderItems',
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    visibleProperty(key) {
      return key.slice(0) !== '_';
    },
    imageSrc(lineItem) {
      return get(lineItem, 'product.image.src');
    },
  }
}
</script>

<style lang="scss" scoped>
.c-order-items {
  &__item {
    padding: rem(10px);
    padding-left: 0;
    @include themify($themes) {
      border-bottom: $border themed('foreground', 'select');
    }
  }
  
  &__item-image {
    height: rem(70px);
    display: inline-block;
    margin-right: rem(30px);
  }
  
  &__item-details {
    flex: 1;
  }
  
  &__item-line {
    margin-top: 0;
    margin-bottom: rem(4px);
  
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>